class middleware {
	get params() {
		return {
			user_type: JSON.parse(localStorage.getItem("authState"))?.user
				?.userType,
		};
	}
}

export default middleware;
